import axios from 'axios';

const API_BASE = '/api/customer-invoices';

export const customerInvoiceService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  getByWorkOrderId: async (workOrderId) => {
    const response = await axios.get(`${API_BASE}/by-order/${workOrderId}`);
    return response.data;
  },

  getOpenByCustomerId: async (customerId) => {
    const response = await axios.get(`${API_BASE}/open-by-customer/${customerId}`);
    return response.data;
  },

  canShip: async (workOrderId) => {
    const response = await axios.get(`${API_BASE}/can-ship/${workOrderId}`);
    return response.data;
  },

  getNextNumber: async () => {
    const response = await axios.get(`${API_BASE}/next-number`);
    return response.data;
  },

  /** Invoice from current order lines (no packing slip). */
  createFromWorkOrder: async (workOrderId) => {
    const response = await axios.post(`${API_BASE}/from-work-order/${workOrderId}`);
    return response.data;
  },

  /** Create invoice from an existing packing slip (shipped qty × order line prices); optional shipping/tax in body. */
  createFromPackingSlip: async (packingSlipId, body = {}) => {
    const response = await axios.post(`${API_BASE}/from-packing-slip/${packingSlipId}`, body);
    return response.data;
  },

  getPartialInvoiceDraft: async (workOrderId) => {
    const response = await axios.get(`${API_BASE}/partial-draft/${workOrderId}`);
    return response.data;
  },

  createFromWorkOrderRemaining: async (workOrderId, body) => {
    const response = await axios.post(`${API_BASE}/from-work-order-remaining/${workOrderId}`, body);
    return response.data;
  },

  /** Payment-schedule invoice (milestones only, no line items). body.schedule: [{ label, amount, due_date }]. */
  createPaymentScheduleFromWorkOrder: async (workOrderId, body) => {
    const response = await axios.post(`${API_BASE}/from-work-order-payment-schedule/${workOrderId}`, body);
    return response.data;
  },

  createFromOrder: async (workOrderId) => {
    const response = await axios.post(`${API_BASE}/from-work-order/${workOrderId}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  markPaid: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/mark-paid`);
    return response.data;
  },

  void: async (id, body = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/void`, body);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
